"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentReplyData = void 0;
var runtypes_1 = require("runtypes");
var runtypeImplementing_1 = require("../../../util/runtypeImplementing");
var UUID_1 = require("../../../util/UUID");
var Data_1 = require("./Data");
exports.CommentReplyData = (0, runtypeImplementing_1.runtypeImplementing)(Data_1.Data)((0, runtypes_1.Record)({
    type: (0, runtypes_1.Literal)("commentReply"),
    contentUuid: UUID_1.UUID,
    contentType: (0, runtypes_1.Union)((0, runtypes_1.Literal)("NEWS_POST"), (0, runtypes_1.Literal)("EVENT_POST"), (0, runtypes_1.Literal)("COMMUNITY_POST")),
    comment: UUID_1.UUID,
    reply: UUID_1.UUID,
    user: UUID_1.UUID,
}));
//# sourceMappingURL=CommentReplyData.js.map